import {styled} from '@mui/material';
import Box from '@mui/material/Box';

export const LeoDeliveryText = styled(Box)(({theme}) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightBold,
  '&.bulky': {
    color: theme.palette.common.mds_global_color_purple_1
  },
  '&.vendor': {
    color: theme.palette.common.mds_global_color_orange_10
  },
  '&.sameday': {
    background: `linear-gradient(90deg, ${theme.palette.common.mds_global_color_red_10} 6.62%, ${theme.palette.common.mds_global_color_orange_90} 100.69%)`,
    backgroundClip: 'text',
    WebkitbackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    lineHeight: theme.spacing(1.8)
  },
  '&.preOrder': {
    color: theme.palette.common.mds_global_color_blue_10,
    fontSize: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.25)
    }
  }
}));
